function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M176.596 43.5126C159.312 17.7374 129.926 0.734253 96.6276 0.734253C43.5786 0.734253 0.415283 43.8976 0.415283 96.9465C0.415283 149.995 43.5786 193.159 96.6276 193.159C129.926 193.159 159.312 176.156 176.596 150.38L169.406 145.573C153.683 169.028 126.929 184.512 96.6276 184.512C48.3445 184.512 9.06252 145.23 9.06252 96.9465C9.06252 48.6635 48.3445 9.38149 96.6276 9.38149C126.929 9.38149 153.672 24.8654 169.406 48.3201L176.596 43.5126Z",
  fill: "#1B1B1B"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M96.6275 124.241C81.5807 124.241 69.333 111.993 69.333 96.9465C69.333 81.8997 81.5807 69.652 96.6275 69.652C106.076 69.652 114.411 74.4803 119.312 81.7956L112.122 86.6031C108.771 81.6083 103.079 78.3097 96.6275 78.3097C86.3465 78.3097 77.9803 86.676 77.9803 96.9569C77.9803 107.238 86.3465 115.604 96.6275 115.604C103.079 115.604 108.771 112.305 112.122 107.311L119.312 112.118C114.401 119.413 106.066 124.241 96.6275 124.241Z",
  fill: "#1B1B1B"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M138.398 124.855L131.218 120.058C123.746 131.213 111.03 138.57 96.6286 138.57C73.6734 138.57 55.0053 119.902 55.0053 96.9466C55.0053 73.9914 73.6734 55.3233 96.6286 55.3233C111.03 55.3233 123.746 62.6802 131.218 73.8353L138.398 69.0382C129.365 55.573 114.017 46.6865 96.6182 46.6865C68.8971 46.6865 46.3477 69.2359 46.3477 96.957C46.3477 124.668 68.8971 147.228 96.6182 147.228C114.017 147.207 129.376 138.32 138.398 124.855Z",
  fill: "#1B1B1B"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M96.6273 170.183C56.2423 170.183 23.3911 137.332 23.3911 96.9465C23.3911 56.5615 56.2423 23.7103 96.6273 23.7103C121.976 23.7103 144.338 36.6551 157.491 56.2805L150.311 61.0776C138.708 43.7727 118.979 32.3471 96.6273 32.3471C61.0082 32.3471 32.028 61.3273 32.028 96.9465C32.028 132.566 61.0082 161.546 96.6273 161.546C118.979 161.546 138.708 150.131 150.311 132.826L157.491 137.623C144.338 157.238 121.966 170.183 96.6273 170.183Z",
  fill: "#1B1B1B"
});

function SvgCompensateBlackMini(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 177 194",
    width: "100%",
    height: "100%",
    preserveAspectRatio: "xMinYMin meet",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompensateBlackMini);
export default __webpack_public_path__ + "static/media/compensate-black-mini.068ff30d.svg";
export { ForwardRef as ReactComponent };